import { Route, Switch } from 'react-router-dom';
import Home from '../pages/Home/Home';

export default function Routing() {
    return(
        <Switch>
            <Route exact path='/' component={Home} />
        </Switch>
    )
}